import { Injectable, inject } from '@angular/core';
import { AbstractSearchFacade } from '@pf/shared-services';
import {
    TimezoneCreate,
    TimezoneDto,
    TimezoneRead,
    TimezoneSearchParams,
} from '../entities/timezone.dto';
import { TimezoneDataService } from '../infrastructure/timezone/timezone.data.service';
import { TimezoneMapper } from '../infrastructure/timezone/timezone.mapper';
import { TimezoneStore } from '../infrastructure/timezone/timezone.store';

@Injectable()
export class TimezoneFacade extends AbstractSearchFacade<
    TimezoneDto,
    TimezoneRead,
    TimezoneCreate,
    TimezoneSearchParams
> {
    private timezoneStore: TimezoneStore;
    private timezoneMapper: TimezoneMapper;

    nameField: keyof TimezoneDto = 'name';

    textSearchFilter(
        searchText: string
    ): Partial<Record<keyof TimezoneDto, string>> {
        return { abbreviation: searchText };
    }

    constructor() {
        const timezoneDataService = inject(TimezoneDataService);
        const timezoneStore = inject(TimezoneStore);
        const timezoneMapper = inject(TimezoneMapper);

        super(timezoneDataService, timezoneStore, timezoneMapper);

        this.timezoneStore = timezoneStore;
        this.timezoneMapper = timezoneMapper;
    }
}
